import { AgeGroup, Under13AgeGroup } from '@best-athletes/ba-types';

/**
 * Returns AgeGroup from an age
 */
export function ageToAgeGroup(ageYears: number, {allowUnder13 = false}: { allowUnder13?: boolean } = {}): AgeGroup | Under13AgeGroup | null {
	/** Playing Level, U14, U16, etc. */
	if (ageYears === null) return null;
	if (allowUnder13 && ageYears < 13){
		if(ageYears < 7) return Under13AgeGroup.U6;
		if(ageYears < 8) return Under13AgeGroup.U7;
		if(ageYears < 9) return Under13AgeGroup.U8;
		if(ageYears < 10) return Under13AgeGroup.U9;
		if(ageYears < 11) return Under13AgeGroup.U10;
		if(ageYears < 12) return Under13AgeGroup.U11;
		if(ageYears < 13) return Under13AgeGroup.U12;
	}
	if (ageYears < 14) return AgeGroup.U13;
	if (ageYears < 15) return AgeGroup.U14;
	if (ageYears < 16) return AgeGroup.U15;
	if (ageYears < 17) return AgeGroup.U16;
	if (ageYears < 18) return AgeGroup.U17;
	if (ageYears < 19) return AgeGroup.U18;
	if (ageYears < 20) return AgeGroup.U19;
	if (ageYears < 21) return AgeGroup.U20;
	if (ageYears >= 21) return AgeGroup.O20;
	return null;
}

export function ageGroupToAge(ageGroup: AgeGroup | Under13AgeGroup): number {
	if( ageGroup == Under13AgeGroup.U6 ) return 6;
	if( ageGroup == Under13AgeGroup.U7 ) return 7;
	if( ageGroup == Under13AgeGroup.U8 ) return 8;
	if( ageGroup == Under13AgeGroup.U9 ) return 9;
	if( ageGroup == Under13AgeGroup.U10 ) return 10;
	if( ageGroup == Under13AgeGroup.U11 ) return 11;
	if( ageGroup == Under13AgeGroup.U12 ) return 12;
	if( ageGroup == AgeGroup.U13 ) return 13;
	if( ageGroup == AgeGroup.U14 ) return 14;
	if( ageGroup == AgeGroup.U15 ) return 15;
	if( ageGroup == AgeGroup.U16 ) return 16;
	if( ageGroup == AgeGroup.U17 ) return 17;
	if( ageGroup == AgeGroup.U18 ) return 18;
	if( ageGroup == AgeGroup.U19 ) return 19;
	if( ageGroup == AgeGroup.U20 ) return 20;
	if( ageGroup == AgeGroup.O20 ) return 21;
}
